import {FetchCAPIError} from '@github-ui/copilot-shared-ui/capi/fetch-capi'

/**
 * Whether a transcript read was refused because the viewer can no longer read
 * something the conversation reached (the Mission Control resume gate).
 *
 * Mission Control answers a refused resume with a bare 403 on the transcript
 * reads. The only other 403 on those routes is a token-scope refusal that the
 * first-party web token never hits, so a 403 there is read as a refused resume.
 */
export function isConversationRefused(error: unknown): boolean {
  return error instanceof FetchCAPIError && error.status === 403
}
